import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../state';
import { AddressType } from './address-type.model';
import { AddressTypeFacadeBase } from './address-type.state';

@Injectable()
export class AddressTypeFacade extends AddressTypeFacadeBase {
  constructor(private store: Store<AppState>) {
    super(AddressType, store);
  }
}
